module.exports = __webpack_public_path__ + "img/HCZ3.d0349d74.jpg";